module.exports = __webpack_public_path__ + "static/img/carousel_2@2x.3404387.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carousel_2@2x.png
// module id = V5+N
// module chunks = 1